import { StateCreator } from 'zustand';

import { Store } from 'store';

export type SelectedItemInfo = {
  id: number;
  title: string;
};

export interface SellApartmentSecondarySlice {
  sellApartmentSearchSecondary: string;
  setSellApartmentSearchSecondary: (value: string) => void;

  selectedSellBuildingSecondary: SelectedItemInfo;
  setSelectedSellBuildingSecondary: (building: SelectedItemInfo) => void;

  sellApartmentNumberSecondary: string;
  setSellApartmentNumberSecondary: (number: string) => void;

  sellAreaInSqMSecondary: string;
  setSellAreaInSqMSecondary: (number: string) => void;

  // sellRoomCountSecondary: string;
  // setSellRoomCountSecondary: (number: string) => void;

  setTypeIdSecondary: (id: number) => void;
  typeIdSecondary: number;

  resetSellFlowSecondary: () => void;
}

const createSellApartmentSecondarySlice: StateCreator<
  Store,
  [['zustand/immer', never]],
  [],
  SellApartmentSecondarySlice
> = (set) => ({
  sellApartmentSearchSecondary: '',
  setSellApartmentSearchSecondary: (value) => set({ sellApartmentSearchSecondary: value }),

  selectedSellBuildingSecondary: {
    id: -1,
    title: '',
  },
  setSelectedSellBuildingSecondary: (building) => set({ selectedSellBuildingSecondary: building }),

  sellApartmentNumberSecondary: '',
  setSellApartmentNumberSecondary: (number) => set({ sellApartmentNumberSecondary: number }),

  sellAreaInSqMSecondary: '',
  setSellAreaInSqMSecondary: (number) => set({ sellAreaInSqMSecondary: number }),

  // sellRoomCountSecondary: '',
  // setSellRoomCountSecondary: (number) => set({ sellRoomCountSecondary: number }),

  setTypeIdSecondary: (id) => set({ typeIdSecondary: id }),
  typeIdSecondary: 0,

  resetSellFlowSecondary: () =>
    set({
      sellApartmentSearchSecondary: '',
      selectedSellBuildingSecondary: {
        id: -1,
        title: '',
      },
      sellApartmentNumberSecondary: '',
    }),
});

export default createSellApartmentSecondarySlice;
